import script from "./admin-overview.vue?vue&type=script&setup=true&lang=js"
export * from "./admin-overview.vue?vue&type=script&setup=true&lang=js"

import "./admin-overview.vue?vue&type=style&index=0&id=79df46f6&lang=scss"

const __exports__ = script;

export default __exports__